import { render, staticRenderFns } from "./questionnaireDetails.vue?vue&type=template&id=9959d532&scoped=true&"
import script from "./questionnaireDetails.vue?vue&type=script&lang=js&"
export * from "./questionnaireDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9959d532",
  null
  
)

export default component.exports